<template>
    <button class="button main" :class="{TA:isTestAchat}" @click="$emit('click')">{{ label ? label : $t('next') }}<SvgIcon class="loading" icon="loading" v-if="loading"></SvgIcon></button>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        loading: {
            type:Boolean
        },
        label: {
            type: String
        }
    },
    computed: {
        ...mapGetters("subscription", ["isTestAchat"])
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Navigation/NextButton.vue